// this is a separate file so we can mock it
export default JSON.stringify as (arg: any) => string;
